const DEFAULT_USABILLA_ID = 'd0c835ea67d8'
// All labs experiences intentionally share one Usabilla channel (DSC-7633, DSC-10236).
const ROUTE_OVERRIDE_USABILLA_ID = 'c711d29c998d'

const routeOverridePaths = [
  '/mytimemachine',
  '/heritage',
  '/myyear',
  '/aam2',
  '/myname',
  '/myfamousrelatives',
  '/saltlakecitytemple',
]

const routeMatchesPath = (routePath, pathname = '') => pathname === routePath || pathname.startsWith(`${routePath}/`)

export const getUsabillaUrl = (pathname = '') => {
  const usabillaId = routeOverridePaths.some((routePath) => routeMatchesPath(routePath, pathname))
    ? ROUTE_OVERRIDE_USABILLA_ID
    : DEFAULT_USABILLA_ID

  return `//w.usabilla.com/${usabillaId}.js`
}

export { DEFAULT_USABILLA_ID, ROUTE_OVERRIDE_USABILLA_ID, routeOverridePaths }
